import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const SearchPersonsMaster = withSuspense(lazy(() => import('./person-master-search')));
export default SearchPersonsMaster;
